// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { removeOnlineCourseFromCart } from '../../apis/ec';
import { removeOnlineCourseFromCartActions } from '../actionCreators/removeOnlineCourseFromCartActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: removeOnlineCourseFromCartActions.success,
  failure: removeOnlineCourseFromCartActions.failure
};

type RequestActionTypes = ActionType<
  typeof removeOnlineCourseFromCartActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const removeOnlineCourseFromCartEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(removeOnlineCourseFromCartActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, callback } = action.payload;
      // send api promise
      return removeOnlineCourseFromCart(id)
        .then((response: any) => {
          // handle success case here
          return removeOnlineCourseFromCartActions.success('');
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return removeOnlineCourseFromCartActions.failure({ error });
        })
        .finally(() => callback())
    })
  );
};
